export default Object.freeze({
  New: 1,
  Submitted: 2,
  Amendment: 3,
});
